/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthorProfile } from '../models/AuthorProfile';
import type { AuthorProfileInput } from '../models/AuthorProfileInput';
import type { Catalog } from '../models/Catalog';
import type { CatalogCoursesInput } from '../models/CatalogCoursesInput';
import type { CatalogDetail } from '../models/CatalogDetail';
import type { CatalogInput } from '../models/CatalogInput';
import type { CleanupInput } from '../models/CleanupInput';
import type { CleanupResult } from '../models/CleanupResult';
import type { Course } from '../models/Course';
import type { CourseDetail } from '../models/CourseDetail';
import type { CourseInput } from '../models/CourseInput';
import type { CourseStatusInput } from '../models/CourseStatusInput';
import type { CourseTranslation } from '../models/CourseTranslation';
import type { CourseTranslationInput } from '../models/CourseTranslationInput';
import type { CourseVersion } from '../models/CourseVersion';
import type { CourseVersionDetail } from '../models/CourseVersionDetail';
import type { DueReviewList } from '../models/DueReviewList';
import type { Editor } from '../models/Editor';
import type { Enrollment } from '../models/Enrollment';
import type { GenerateCourseInput } from '../models/GenerateCourseInput';
import type { GeneratedCourse } from '../models/GeneratedCourse';
import type { GrantEditorInput } from '../models/GrantEditorInput';
import type { HandleAvailability } from '../models/HandleAvailability';
import type { KahootAdminState } from '../models/KahootAdminState';
import type { KahootAnswerInput } from '../models/KahootAnswerInput';
import type { KahootJoinInput } from '../models/KahootJoinInput';
import type { KahootLaunchInput } from '../models/KahootLaunchInput';
import type { KahootPhaseInput } from '../models/KahootPhaseInput';
import type { KahootPublicState } from '../models/KahootPublicState';
import type { KahootStartInput } from '../models/KahootStartInput';
import type { Lesson } from '../models/Lesson';
import type { LessonInput } from '../models/LessonInput';
import type { LessonManifest } from '../models/LessonManifest';
import type { LessonNotes } from '../models/LessonNotes';
import type { LessonPreview } from '../models/LessonPreview';
import type { LessonState } from '../models/LessonState';
import type { LessonStateInput } from '../models/LessonStateInput';
import type { LessonStatusInput } from '../models/LessonStatusInput';
import type { LessonTranslation } from '../models/LessonTranslation';
import type { LessonTranslationInput } from '../models/LessonTranslationInput';
import type { LmsFeatures } from '../models/LmsFeatures';
import type { LmsUsage } from '../models/LmsUsage';
import type { ManagedAsset } from '../models/ManagedAsset';
import type { PollHistory } from '../models/PollHistory';
import type { PollPublicState } from '../models/PollPublicState';
import type { PollRoom } from '../models/PollRoom';
import type { PollVoteInput } from '../models/PollVoteInput';
import type { PollVoteResult } from '../models/PollVoteResult';
import type { PreviewInput } from '../models/PreviewInput';
import type { ProgressInput } from '../models/ProgressInput';
import type { PublicAuthorSpace } from '../models/PublicAuthorSpace';
import type { PublicCatalog } from '../models/PublicCatalog';
import type { QAFeed } from '../models/QAFeed';
import type { QAItem } from '../models/QAItem';
import type { QAStatusInput } from '../models/QAStatusInput';
import type { QASubmitInput } from '../models/QASubmitInput';
import type { QAUpvoteResult } from '../models/QAUpvoteResult';
import type { QuizAttemptInput } from '../models/QuizAttemptInput';
import type { QuizAttemptResult } from '../models/QuizAttemptResult';
import type { RecompileReport } from '../models/RecompileReport';
import type { RemixInput } from '../models/RemixInput';
import type { RemixResult } from '../models/RemixResult';
import type { RemoteCommandInput } from '../models/RemoteCommandInput';
import type { RemoteState } from '../models/RemoteState';
import type { ReorderLessonsInput } from '../models/ReorderLessonsInput';
import type { Review } from '../models/Review';
import type { ReviewInput } from '../models/ReviewInput';
import type { SetPollQuestionInput } from '../models/SetPollQuestionInput';
import type { ShareSettings } from '../models/ShareSettings';
import type { SrsReviewInput } from '../models/SrsReviewInput';
import type { SrsReviewResult } from '../models/SrsReviewResult';
import type { WordcloudInput } from '../models/WordcloudInput';
import type { CancelablePromise } from 'core-fe-lib/openapi/core/core/CancelablePromise';
import { OpenAPI } from 'core-fe-lib/openapi/core/core/OpenAPI';
import { request as __request } from 'core-fe-lib/openapi/core/core/request';
export class DefaultService {
    /**
     * @param page
     * @param pageSize
     * @param q
     * @returns Course courses
     * @throws ApiError
     */
    public static listCoursesAdmin(
        page?: number,
        pageSize?: number,
        q?: string,
    ): CancelablePromise<Array<Course>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses',
            query: {
                'page': page,
                'pageSize': pageSize,
                'q': q,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Course created
     * @throws ApiError
     */
    public static createCourse(
        requestBody: CourseInput,
    ): CancelablePromise<Course> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Instant draft: from one prompt, synchronously generate a complete themed draft course (course + every lesson) using the impactful method. Returns the new draft course and its lessons. Nothing is published.
     *
     * @param requestBody
     * @returns GeneratedCourse generated draft course
     * @throws ApiError
     */
    public static generateCourse(
        requestBody: GenerateCourseInput,
    ): CancelablePromise<GeneratedCourse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses/generate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Streaming instant draft (Server-Sent Events). Same input as generateCourse, but emits progress as it builds: an `outline` event (course title, theme, lesson titles), a `course` event (the created draft id), one `lesson` event per lesson as it compiles, then `done`. Lets the UI reveal the course building itself instead of waiting.
     *
     * @param requestBody
     * @returns string SSE stream of draft-build events
     * @throws ApiError
     */
    public static generateCourseStream(
        requestBody: GenerateCourseInput,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses/generate/stream',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param courseId
     * @returns Course course
     * @throws ApiError
     */
    public static getCourseAdmin(
        courseId: string,
    ): CancelablePromise<Course> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses/{courseId}',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * @param courseId
     * @param requestBody
     * @returns Course updated
     * @throws ApiError
     */
    public static updateCourse(
        courseId: string,
        requestBody: CourseInput,
    ): CancelablePromise<Course> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/courses/{courseId}',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param courseId
     * @returns void
     * @throws ApiError
     */
    public static deleteCourse(
        courseId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/lms/admin/courses/{courseId}',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * @param courseId
     * @param requestBody
     * @returns Course updated
     * @throws ApiError
     */
    public static setCourseStatus(
        courseId: string,
        requestBody: CourseStatusInput,
    ): CancelablePromise<Course> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/courses/{courseId}/status',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * One-click publish: set the course to published and publish every one of its lessons in a single transaction.
     *
     * @param courseId
     * @returns Course published course
     * @throws ApiError
     */
    public static publishCourse(
        courseId: string,
    ): CancelablePromise<Course> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses/{courseId}/publish',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * Audit history of published snapshots for the course, newest first (metadata only, no snapshot payload).
     *
     * @param courseId
     * @returns CourseVersion version history
     * @throws ApiError
     */
    public static listCourseVersions(
        courseId: string,
    ): CancelablePromise<Array<CourseVersion>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses/{courseId}/versions',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * One published snapshot including its full frozen payload (inspect/diff).
     * @param courseId
     * @param version
     * @returns CourseVersionDetail version detail
     * @throws ApiError
     */
    public static getCourseVersion(
        courseId: string,
        version: number,
    ): CancelablePromise<CourseVersionDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses/{courseId}/versions/{version}',
            path: {
                'courseId': courseId,
                'version': version,
            },
            errors: {
                404: `unknown version`,
            },
        });
    }
    /**
     * Restore the course's content to a prior version. Append-only and learner-safe: the current state is auto-snapshotted first, lessons added since the target are unpublished (never deleted), and enrollments / progress are untouched. Returns the restored course.
     *
     * @param courseId
     * @param version
     * @returns Course restored course
     * @throws ApiError
     */
    public static rollbackCourse(
        courseId: string,
        version: number,
    ): CancelablePromise<Course> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses/{courseId}/versions/{version}/rollback',
            path: {
                'courseId': courseId,
                'version': version,
            },
            errors: {
                404: `unknown version`,
            },
        });
    }
    /**
     * @param courseId
     * @returns CourseTranslation course translations
     * @throws ApiError
     */
    public static listCourseTranslations(
        courseId: string,
    ): CancelablePromise<Array<CourseTranslation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses/{courseId}/translations',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * @param courseId
     * @param lang
     * @param requestBody
     * @returns CourseTranslation upserted
     * @throws ApiError
     */
    public static upsertCourseTranslation(
        courseId: string,
        lang: string,
        requestBody: CourseTranslationInput,
    ): CancelablePromise<CourseTranslation> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/courses/{courseId}/translations/{lang}',
            path: {
                'courseId': courseId,
                'lang': lang,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param courseId
     * @returns Lesson lessons
     * @throws ApiError
     */
    public static listLessonsAdmin(
        courseId: string,
    ): CancelablePromise<Array<Lesson>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses/{courseId}/lessons',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * @param courseId
     * @param requestBody
     * @returns Lesson created (manifest compiled from sourceMd)
     * @throws ApiError
     */
    public static createLesson(
        courseId: string,
        requestBody: LessonInput,
    ): CancelablePromise<Lesson> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses/{courseId}/lessons',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid lesson markdown`,
            },
        });
    }
    /**
     * Reassign lesson positions (0-based) to match the given order. lessonIds must cover every lesson in the course exactly once. Returns the lessons in their new order.
     *
     * @param courseId
     * @param requestBody
     * @returns Lesson lessons in new order
     * @throws ApiError
     */
    public static reorderLessons(
        courseId: string,
        requestBody: ReorderLessonsInput,
    ): CancelablePromise<Array<Lesson>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses/{courseId}/lessons/reorder',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ids do not cover the course's lessons exactly once`,
            },
        });
    }
    /**
     * Current public-share state for a course: whether a share link is active, the link itself, and lightweight view analytics (opens, unique visitors, lessons reached, quiz attempts).
     *
     * @param courseId
     * @returns ShareSettings share settings
     * @throws ApiError
     */
    public static getCourseShare(
        courseId: string,
    ): CancelablePromise<ShareSettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses/{courseId}/share',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * Enable a public read-only share link for the course, minting a token if none exists. Idempotent — returns the existing link when already shared.
     *
     * @param courseId
     * @returns ShareSettings share enabled
     * @throws ApiError
     */
    public static enableCourseShare(
        courseId: string,
    ): CancelablePromise<ShareSettings> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/courses/{courseId}/share',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * Revoke the public share link (existing links stop working).
     * @param courseId
     * @returns void
     * @throws ApiError
     */
    public static disableCourseShare(
        courseId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/lms/admin/courses/{courseId}/share',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * @param lessonId
     * @returns Lesson lesson
     * @throws ApiError
     */
    public static getLessonAdmin(
        lessonId: string,
    ): CancelablePromise<Lesson> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/lessons/{lessonId}',
            path: {
                'lessonId': lessonId,
            },
        });
    }
    /**
     * @param lessonId
     * @param requestBody
     * @returns Lesson updated (manifest recompiled)
     * @throws ApiError
     */
    public static updateLesson(
        lessonId: string,
        requestBody: LessonInput,
    ): CancelablePromise<Lesson> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/lessons/{lessonId}',
            path: {
                'lessonId': lessonId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid lesson markdown`,
            },
        });
    }
    /**
     * @param lessonId
     * @returns void
     * @throws ApiError
     */
    public static deleteLesson(
        lessonId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/lms/admin/lessons/{lessonId}',
            path: {
                'lessonId': lessonId,
            },
        });
    }
    /**
     * @param lessonId
     * @param requestBody
     * @returns Lesson updated
     * @throws ApiError
     */
    public static setLessonStatus(
        lessonId: string,
        requestBody: LessonStatusInput,
    ): CancelablePromise<Lesson> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/lessons/{lessonId}/status',
            path: {
                'lessonId': lessonId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param lessonId
     * @returns LessonTranslation lesson translations
     * @throws ApiError
     */
    public static listLessonTranslations(
        lessonId: string,
    ): CancelablePromise<Array<LessonTranslation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/lessons/{lessonId}/translations',
            path: {
                'lessonId': lessonId,
            },
        });
    }
    /**
     * Upsert a localized lesson variant. The translated sourceMd is compiled on write; its quiz blocks must keep the same ids and correct options as the base lesson (shared answer keys) or the request is rejected 400.
     *
     * @param lessonId
     * @param lang
     * @param requestBody
     * @returns LessonTranslation upserted
     * @throws ApiError
     */
    public static upsertLessonTranslation(
        lessonId: string,
        lang: string,
        requestBody: LessonTranslationInput,
    ): CancelablePromise<LessonTranslation> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/lessons/{lessonId}/translations/{lang}',
            path: {
                'lessonId': lessonId,
                'lang': lang,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid markdown or quiz parity mismatch`,
            },
        });
    }
    /**
     * Per-slide speaker notes for a lesson, compiled from ::: notes directives. Admin-only — these are stripped from the learner manifest by design and feed the presenter-mode notes panel.
     *
     * @param lessonId
     * @returns LessonNotes presenter notes
     * @throws ApiError
     */
    public static getLessonNotes(
        lessonId: string,
    ): CancelablePromise<LessonNotes> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/lessons/{lessonId}/notes',
            path: {
                'lessonId': lessonId,
            },
        });
    }
    /**
     * Re-parse every lesson's stored Markdown source and rewrite its manifest, prose projection, and quiz answer keys. Use to backfill lessons whose stored manifest predates a parser change. Idempotent; source_md is never modified.
     *
     * @returns RecompileReport recompile report
     * @throws ApiError
     */
    public static recompileLessons(): CancelablePromise<RecompileReport> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/lessons/recompile',
        });
    }
    /**
     * List every LMS-managed image with its reference status and scheduled deletion time. Diagnostic view for the orphaned-image GC.
     *
     * @returns ManagedAsset managed assets
     * @throws ApiError
     */
    public static listManagedAssets(): CancelablePromise<Array<ManagedAsset>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/assets',
        });
    }
    /**
     * Reap unreferenced images now. With force=true the grace window is ignored (every current orphan is deleted immediately); otherwise it matches the background sweep.
     *
     * @param requestBody
     * @returns CleanupResult cleanup result
     * @throws ApiError
     */
    public static cleanupAssets(
        requestBody?: CleanupInput,
    ): CancelablePromise<CleanupResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/assets/cleanup',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns LessonPreview compiled manifest (no persistence, no answer keys)
     * @throws ApiError
     */
    public static previewLesson(
        requestBody: PreviewInput,
    ): CancelablePromise<LessonPreview> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid markdown`,
            },
        });
    }
    /**
     * Rewrite ONE slide's Markdown by an instruction (AI). Stateless — reads and writes nothing; returns a suggestion the author previews and applies client-side via the normal save path. canAuthor-gated.
     *
     * @param requestBody
     * @returns RemixResult the rewritten slide Markdown
     * @throws ApiError
     */
    public static remixSlide(
        requestBody: RemixInput,
    ): CancelablePromise<RemixResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/remix',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `empty slide content`,
            },
        });
    }
    /**
     * List users granted the LMS editor capability. Admins are editors implicitly and are not listed here. Admin-gated.
     *
     * @returns Editor editors
     * @throws ApiError
     */
    public static listEditors(): CancelablePromise<Array<Editor>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/editors',
        });
    }
    /**
     * Grant the LMS editor capability to a tenant user. Admin-gated.
     * @param requestBody
     * @returns Editor granted
     * @throws ApiError
     */
    public static grantEditor(
        requestBody: GrantEditorInput,
    ): CancelablePromise<Editor> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/editors',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Revoke the LMS editor capability from a user. Admin-gated.
     * @param userId
     * @returns void
     * @throws ApiError
     */
    public static revokeEditor(
        userId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/lms/admin/editors/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * The caller's author-space profile (handle + branding). 404 when they have not created their space yet.
     *
     * @returns AuthorProfile author profile
     * @throws ApiError
     */
    public static getMyAuthorProfile(): CancelablePromise<AuthorProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/author-profile',
            errors: {
                404: `no space yet`,
            },
        });
    }
    /**
     * Create or update the caller's author space. The handle is normalized to a slug and must be unique within the tenant.
     *
     * @param requestBody
     * @returns AuthorProfile saved profile
     * @throws ApiError
     */
    public static upsertMyAuthorProfile(
        requestBody: AuthorProfileInput,
    ): CancelablePromise<AuthorProfile> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/author-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `invalid handle`,
                409: `handle already taken`,
            },
        });
    }
    /**
     * Check whether a desired space handle is free for the caller.
     * @param handle
     * @returns HandleAvailability availability
     * @throws ApiError
     */
    public static checkHandleAvailable(
        handle: string,
    ): CancelablePromise<HandleAvailability> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/author-profile/handle-available',
            query: {
                'handle': handle,
            },
            errors: {
                400: `invalid handle`,
            },
        });
    }
    /**
     * Every catalog under the caller's space (any status).
     * @returns Catalog catalogs
     * @throws ApiError
     */
    public static listMyCatalogs(): CancelablePromise<Array<Catalog>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/catalogs',
            errors: {
                404: `no space yet`,
            },
        });
    }
    /**
     * Add a catalog to the caller's space (slug derived from the title when empty).
     * @param requestBody
     * @returns Catalog created
     * @throws ApiError
     */
    public static createCatalog(
        requestBody: CatalogInput,
    ): CancelablePromise<Catalog> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/admin/catalogs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `no space yet`,
            },
        });
    }
    /**
     * One of the caller's catalogs with its ordered courses (any status).
     * @param catalogId
     * @returns CatalogDetail catalog detail
     * @throws ApiError
     */
    public static getCatalog(
        catalogId: string,
    ): CancelablePromise<CatalogDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/catalogs/{catalogId}',
            path: {
                'catalogId': catalogId,
            },
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * @param catalogId
     * @param requestBody
     * @returns Catalog updated
     * @throws ApiError
     */
    public static updateCatalog(
        catalogId: string,
        requestBody: CatalogInput,
    ): CancelablePromise<Catalog> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/catalogs/{catalogId}',
            path: {
                'catalogId': catalogId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `not found`,
            },
        });
    }
    /**
     * @param catalogId
     * @returns void
     * @throws ApiError
     */
    public static deleteCatalog(
        catalogId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/lms/admin/catalogs/{catalogId}',
            path: {
                'catalogId': catalogId,
            },
        });
    }
    /**
     * Replace the catalog's courses with the given ordered ids (position = index). Only courses you own may be listed.
     *
     * @param catalogId
     * @param requestBody
     * @returns CatalogDetail updated catalog detail
     * @throws ApiError
     */
    public static setCatalogCourses(
        catalogId: string,
        requestBody: CatalogCoursesInput,
    ): CancelablePromise<CatalogDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/catalogs/{catalogId}/courses',
            path: {
                'catalogId': catalogId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `a listed course is not yours`,
                404: `catalog not found`,
            },
        });
    }
    /**
     * The author's hand-picked featured courses (any status), in order.
     * @returns Course featured courses
     * @throws ApiError
     */
    public static listFeaturedCourses(): CancelablePromise<Array<Course>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/featured-courses',
            errors: {
                404: `no space yet`,
            },
        });
    }
    /**
     * Replace the featured rail with the given ordered course ids (position = index). Only courses you own may be featured. An empty list clears the rail, falling back to the enrollment-ranked default on the public space.
     *
     * @param requestBody
     * @returns Course updated featured courses
     * @throws ApiError
     */
    public static setFeaturedCourses(
        requestBody: CatalogCoursesInput,
    ): CancelablePromise<Array<Course>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/admin/featured-courses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `a listed course is not yours`,
                404: `no space yet`,
            },
        });
    }
    /**
     * The marketplace projection of a published author space by handle — profile, derived social proof, learning paths and popular courses. 404 when the handle is unknown or the space is unpublished.
     *
     * @param handle
     * @param lang
     * @returns PublicAuthorSpace author space
     * @throws ApiError
     */
    public static getPublicAuthorSpace(
        handle: string,
        lang?: string,
    ): CancelablePromise<PublicAuthorSpace> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/by/{handle}',
            path: {
                'handle': handle,
            },
            query: {
                'lang': lang,
            },
            errors: {
                404: `unknown handle`,
            },
        });
    }
    /**
     * A published catalog and its published courses by (handle, catalogSlug). 404 unless both the space and the catalog are published.
     *
     * @param handle
     * @param catalogSlug
     * @param lang
     * @returns PublicCatalog catalog with courses
     * @throws ApiError
     */
    public static getPublicCatalog(
        handle: string,
        catalogSlug: string,
        lang?: string,
    ): CancelablePromise<PublicCatalog> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/by/{handle}/{catalogSlug}',
            path: {
                'handle': handle,
                'catalogSlug': catalogSlug,
            },
            query: {
                'lang': lang,
            },
            errors: {
                404: `unknown`,
            },
        });
    }
    /**
     * Sales-page projection (curriculum titles, no enrollment) for one of the author's published, public courses, reached at the space level (independent of any catalog). Works regardless of the tenant-wide public-catalog opt-in. 404 unless the space is published and the course qualifies.
     *
     * @param handle
     * @param courseSlug
     * @param lang
     * @returns CourseDetail course detail with curriculum
     * @throws ApiError
     */
    public static getPublicAuthorCourse(
        handle: string,
        courseSlug: string,
        lang?: string,
    ): CancelablePromise<CourseDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/by/{handle}/c/{courseSlug}',
            path: {
                'handle': handle,
                'courseSlug': courseSlug,
            },
            query: {
                'lang': lang,
            },
            errors: {
                404: `unknown`,
            },
        });
    }
    /**
     * Published courses for anonymous visitors. 404 when the tenant has not opted into the public catalog (lmsPublicCatalog feature off).
     *
     * @param page
     * @param pageSize
     * @param q
     * @param tag
     * @param lang
     * @returns Course published courses
     * @throws ApiError
     */
    public static listPublicCatalog(
        page?: number,
        pageSize?: number,
        q?: string,
        tag?: string,
        lang?: string,
    ): CancelablePromise<Array<Course>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/catalog',
            query: {
                'page': page,
                'pageSize': pageSize,
                'q': q,
                'tag': tag,
                'lang': lang,
            },
            errors: {
                404: `public catalog not enabled for this tenant`,
            },
        });
    }
    /**
     * @param slug
     * @param lang
     * @returns CourseDetail course detail with curriculum (titles only, never enrolled)
     * @throws ApiError
     */
    public static getPublicCourseDetail(
        slug: string,
        lang?: string,
    ): CancelablePromise<CourseDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/catalog/{slug}',
            path: {
                'slug': slug,
            },
            query: {
                'lang': lang,
            },
            errors: {
                404: `public catalog not enabled`,
            },
        });
    }
    /**
     * Read-only learner view of a published course via its share token — no account required. The token (not a feature flag) is the grant, so even a private course is reachable by anyone holding the link. Records a course-open analytics event. 404 when the token is unknown or the course is not published.
     *
     * @param token
     * @param lang
     * @returns CourseDetail course detail with curriculum (titles only)
     * @throws ApiError
     */
    public static getSharedCourse(
        token: string,
        lang?: string,
    ): CancelablePromise<CourseDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/shared/{token}',
            path: {
                'token': token,
            },
            query: {
                'lang': lang,
            },
            errors: {
                404: `unknown token`,
            },
        });
    }
    /**
     * A published lesson's learner manifest (no answer keys) via the course share token. Records a lesson-view analytics event.
     *
     * @param token
     * @param lessonId
     * @param lang
     * @returns LessonManifest lesson manifest (no answer keys)
     * @throws ApiError
     */
    public static getSharedLesson(
        token: string,
        lessonId: string,
        lang?: string,
    ): CancelablePromise<LessonManifest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/shared/{token}/lessons/{lessonId}',
            path: {
                'token': token,
                'lessonId': lessonId,
            },
            query: {
                'lang': lang,
            },
            errors: {
                404: `unknown token/lesson`,
            },
        });
    }
    /**
     * Grade a quiz attempt in the shared learner view (server-authoritative, no account). Records a quiz-attempt analytics event but no per-user state.
     *
     * @param token
     * @param lessonId
     * @param quizId
     * @param requestBody
     * @returns QuizAttemptResult graded server-side
     * @throws ApiError
     */
    public static submitSharedQuizAttempt(
        token: string,
        lessonId: string,
        quizId: string,
        requestBody: QuizAttemptInput,
    ): CancelablePromise<QuizAttemptResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/shared/{token}/lessons/{lessonId}/quiz/{quizId}/attempt',
            path: {
                'token': token,
                'lessonId': lessonId,
                'quizId': quizId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `unknown token/lesson`,
            },
        });
    }
    /**
     * Current question for an anonymous voter who scanned the room QR. Issues a voter cookie if absent. 404 when live polls are disabled or the code is unknown (existence is not leaked).
     *
     * @param joinCode
     * @returns PollPublicState current poll state
     * @throws ApiError
     */
    public static getPollState(
        joinCode: string,
    ): CancelablePromise<PollPublicState> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/poll/{joinCode}',
            path: {
                'joinCode': joinCode,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * @param joinCode
     * @param requestBody
     * @returns PollVoteResult vote recorded; returns the live tally
     * @throws ApiError
     */
    public static castVote(
        joinCode: string,
        requestBody: PollVoteInput,
    ): CancelablePromise<PollVoteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/poll/{joinCode}/vote',
            path: {
                'joinCode': joinCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
                409: `no active question`,
            },
        });
    }
    /**
     * Submit free-text words to the active wordcloud question (anonymous).
     * @param joinCode
     * @param requestBody
     * @returns PollVoteResult text recorded; returns the live word tally
     * @throws ApiError
     */
    public static submitWordcloudText(
        joinCode: string,
        requestBody: WordcloudInput,
    ): CancelablePromise<PollVoteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/poll/{joinCode}/text',
            path: {
                'joinCode': joinCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
                409: `no active question`,
            },
        });
    }
    /**
     * List the visible Q&A feed for the active question (anonymous).
     * @param joinCode
     * @returns QAItem ranked Q&A items
     * @throws ApiError
     */
    public static listQuestions(
        joinCode: string,
    ): CancelablePromise<Array<QAItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/poll/{joinCode}/qa',
            path: {
                'joinCode': joinCode,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Submit an audience question to the active Q&A block (anonymous).
     * @param joinCode
     * @param requestBody
     * @returns QAItem question recorded
     * @throws ApiError
     */
    public static submitQuestion(
        joinCode: string,
        requestBody: QASubmitInput,
    ): CancelablePromise<QAItem> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/poll/{joinCode}/qa',
            path: {
                'joinCode': joinCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
                409: `no active question`,
            },
        });
    }
    /**
     * Toggle this device's upvote on a Q&A item (anonymous).
     * @param joinCode
     * @param itemId
     * @returns QAUpvoteResult upvote toggled
     * @throws ApiError
     */
    public static toggleQuestionUpvote(
        joinCode: string,
        itemId: string,
    ): CancelablePromise<QAUpvoteResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/poll/{joinCode}/qa/{itemId}/upvote',
            path: {
                'joinCode': joinCode,
                'itemId': itemId,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * A player's competitive-quiz view for the current phase (anonymous).
     * @param joinCode
     * @returns KahootPublicState player game state
     * @throws ApiError
     */
    public static getKahootState(
        joinCode: string,
    ): CancelablePromise<KahootPublicState> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/poll/{joinCode}/kahoot',
            path: {
                'joinCode': joinCode,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Join the competitive quiz with a nickname (anonymous).
     * @param joinCode
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static joinKahoot(
        joinCode: string,
        requestBody: KahootJoinInput,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/poll/{joinCode}/kahoot/join',
            path: {
                'joinCode': joinCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
                409: `no active game`,
            },
        });
    }
    /**
     * Submit a timed answer to the active quiz question (anonymous).
     * @param joinCode
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static answerKahoot(
        joinCode: string,
        requestBody: KahootAnswerInput,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/poll/{joinCode}/kahoot/answer',
            path: {
                'joinCode': joinCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
                409: `no active question`,
            },
        });
    }
    /**
     * Send a deck command from a paired phone (the code is the secret).
     * @param code
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static sendRemoteCommand(
        code: string,
        requestBody: RemoteCommandInput,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-api/v1/lms/remote/{code}',
            path: {
                'code': code,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `unknown remote code`,
            },
        });
    }
    /**
     * Server-Sent Events stream of the live tally for the active question.
     * @param joinCode
     * @returns string SSE stream of PollVoteResult events
     * @throws ApiError
     */
    public static streamPollResults(
        joinCode: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-api/v1/lms/poll/{joinCode}/live',
            path: {
                'joinCode': joinCode,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Presenter's live view of the room (join code/QR + current question + tally).
     * @param courseId
     * @returns PollRoom poll room state
     * @throws ApiError
     */
    public static getPollAdminState(
        courseId: string,
    ): CancelablePromise<PollRoom> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/courses/{courseId}/poll',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Ensure a poll room (stable join code/QR) and an active session exist for this presenter.
     * @param courseId
     * @returns PollRoom poll room ready
     * @throws ApiError
     */
    public static openPollRoom(
        courseId: string,
    ): CancelablePromise<PollRoom> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/poll/open',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Open a specific poll block (advance to the poll on the current slide).
     * @param courseId
     * @param requestBody
     * @returns PollRoom question opened
     * @throws ApiError
     */
    public static setPollQuestion(
        courseId: string,
        requestBody: SetPollQuestionInput,
    ): CancelablePromise<PollRoom> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/poll/question',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Reset the live counters by rotating to a fresh session under the same join code/QR. Old votes are retained for audit. Keyed by (tenant, course, presenter).
     *
     * @param courseId
     * @returns PollRoom counters reset
     * @throws ApiError
     */
    public static resetPoll(
        courseId: string,
    ): CancelablePromise<PollRoom> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/poll/reset',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * @param courseId
     * @returns void
     * @throws ApiError
     */
    public static closePollRoom(
        courseId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/poll/close',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Presenter Q&A feed for the active session (includes hidden items).
     * @param courseId
     * @returns QAFeed Q&A feed
     * @throws ApiError
     */
    public static listQuestionsAdmin(
        courseId: string,
    ): CancelablePromise<QAFeed> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/courses/{courseId}/qa',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Mark a Q&A item open / answered / hidden (presenter, room owner only).
     * @param courseId
     * @param itemId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static setQuestionStatus(
        courseId: string,
        itemId: string,
        requestBody: QAStatusInput,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/qa/{itemId}/status',
            path: {
                'courseId': courseId,
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Presenter competitive-quiz game state.
     * @param courseId
     * @returns KahootAdminState game state
     * @throws ApiError
     */
    public static getKahootAdmin(
        courseId: string,
    ): CancelablePromise<KahootAdminState> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/courses/{courseId}/kahoot',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Start a competitive-quiz game on a lesson (lobby phase).
     * @param courseId
     * @param requestBody
     * @returns KahootAdminState game started
     * @throws ApiError
     */
    public static startKahoot(
        courseId: string,
        requestBody: KahootStartInput,
    ): CancelablePromise<KahootAdminState> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/kahoot/start',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Open a quiz block as the active timed question.
     * @param courseId
     * @param requestBody
     * @returns KahootAdminState question launched
     * @throws ApiError
     */
    public static launchKahootQuestion(
        courseId: string,
        requestBody: KahootLaunchInput,
    ): CancelablePromise<KahootAdminState> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/kahoot/launch',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Advance the game to reveal / leaderboard / ended.
     * @param courseId
     * @param requestBody
     * @returns KahootAdminState phase set
     * @throws ApiError
     */
    public static setKahootPhase(
        courseId: string,
        requestBody: KahootPhaseInput,
    ): CancelablePromise<KahootAdminState> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/kahoot/phase',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `live polls not enabled`,
            },
        });
    }
    /**
     * Tenant LMS capability flags, for gating authoring/presenter UI.
     * @returns LmsFeatures feature flags
     * @throws ApiError
     */
    public static getLmsFeatures(): CancelablePromise<LmsFeatures> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/features',
        });
    }
    /**
     * Tenant LMS plan usage vs. caps (ADR 024), for the studio meter.
     * @returns LmsUsage usage summary
     * @throws ApiError
     */
    public static getLmsUsage(): CancelablePromise<LmsUsage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/usage',
        });
    }
    /**
     * Presenter phone-remote channel state (latest command + seq).
     * @param courseId
     * @returns RemoteState remote state
     * @throws ApiError
     */
    public static getRemoteState(
        courseId: string,
    ): CancelablePromise<RemoteState> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/courses/{courseId}/remote',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `no remote open`,
            },
        });
    }
    /**
     * Open (or reuse) a phone-remote channel; returns the private code + QR.
     * @param courseId
     * @returns RemoteState remote ready
     * @throws ApiError
     */
    public static openRemote(
        courseId: string,
    ): CancelablePromise<RemoteState> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/remote/open',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * Poll dashboard — every poll question in the course and each recorded run of it over time, across all presenters. Admin only.
     *
     * @param courseId
     * @returns PollHistory poll history
     * @throws ApiError
     */
    public static getPollHistory(
        courseId: string,
    ): CancelablePromise<PollHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/admin/courses/{courseId}/poll/history',
            path: {
                'courseId': courseId,
            },
            errors: {
                403: `admin required`,
            },
        });
    }
    /**
     * @param page
     * @param pageSize
     * @param q
     * @param tag
     * @param lang
     * @returns Course published courses
     * @throws ApiError
     */
    public static listCatalog(
        page?: number,
        pageSize?: number,
        q?: string,
        tag?: string,
        lang?: string,
    ): CancelablePromise<Array<Course>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/catalog',
            query: {
                'page': page,
                'pageSize': pageSize,
                'q': q,
                'tag': tag,
                'lang': lang,
            },
        });
    }
    /**
     * @param slug
     * @param lang
     * @returns CourseDetail course detail with curriculum
     * @throws ApiError
     */
    public static getCourseDetail(
        slug: string,
        lang?: string,
    ): CancelablePromise<CourseDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/catalog/{slug}',
            path: {
                'slug': slug,
            },
            query: {
                'lang': lang,
            },
        });
    }
    /**
     * @param courseId
     * @param lang
     * @returns CourseDetail course detail with curriculum + the caller's lesson states
     * @throws ApiError
     */
    public static getCourseById(
        courseId: string,
        lang?: string,
    ): CancelablePromise<CourseDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/courses/{courseId}',
            path: {
                'courseId': courseId,
            },
            query: {
                'lang': lang,
            },
        });
    }
    /**
     * @param courseId
     * @returns Enrollment enrolled
     * @throws ApiError
     */
    public static enrollInCourse(
        courseId: string,
    ): CancelablePromise<Enrollment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/courses/{courseId}/enroll',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * @returns Enrollment my enrollments
     * @throws ApiError
     */
    public static listMyEnrollments(): CancelablePromise<Array<Enrollment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/enrollments',
        });
    }
    /**
     * @param courseId
     * @param lessonId
     * @param lang
     * @returns LessonManifest lesson manifest (no answer keys)
     * @throws ApiError
     */
    public static getLessonForLearner(
        courseId: string,
        lessonId: string,
        lang?: string,
    ): CancelablePromise<LessonManifest> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/courses/{courseId}/lessons/{lessonId}',
            path: {
                'courseId': courseId,
                'lessonId': lessonId,
            },
            query: {
                'lang': lang,
            },
            errors: {
                403: `not enrolled`,
            },
        });
    }
    /**
     * @param lessonId
     * @param quizId
     * @param requestBody
     * @returns QuizAttemptResult graded server-side
     * @throws ApiError
     */
    public static submitQuizAttempt(
        lessonId: string,
        quizId: string,
        requestBody: QuizAttemptInput,
    ): CancelablePromise<QuizAttemptResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/lessons/{lessonId}/quiz/{quizId}/attempt',
            path: {
                'lessonId': lessonId,
                'quizId': quizId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param lessonId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static recordLessonProgress(
        lessonId: string,
        requestBody: ProgressInput,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/lessons/{lessonId}/progress',
            path: {
                'lessonId': lessonId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param lessonId
     * @param requestBody
     * @returns LessonState state
     * @throws ApiError
     */
    public static upsertLessonState(
        lessonId: string,
        requestBody: LessonStateInput,
    ): CancelablePromise<LessonState> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/lessons/{lessonId}/state',
            path: {
                'lessonId': lessonId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Record a self-graded spaced-repetition review of a flashcard (or quiz) and advance its SM-2 schedule. Returns the next due date. Upserts the per-learner scheduling row, creating it on first review.
     *
     * @param requestBody
     * @returns SrsReviewResult schedule advanced
     * @throws ApiError
     */
    public static recordSrsReview(
        requestBody: SrsReviewInput,
    ): CancelablePromise<SrsReviewResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/lms/srs/reviews',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `not enrolled`,
            },
        });
    }
    /**
     * The learner's "due today" review queue across all active enrollments — flashcards/quizzes whose scheduled due date has passed, with course and lesson context, ordered most-overdue first.
     *
     * @param limit
     * @returns DueReviewList due review queue
     * @throws ApiError
     */
    public static listDueReviews(
        limit?: number,
    ): CancelablePromise<DueReviewList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/srs/due',
            query: {
                'limit': limit,
            },
        });
    }
    /**
     * @param courseId
     * @param page
     * @param pageSize
     * @returns Review visible reviews
     * @throws ApiError
     */
    public static listCourseReviews(
        courseId: string,
        page?: number,
        pageSize?: number,
    ): CancelablePromise<Array<Review>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/lms/courses/{courseId}/reviews',
            path: {
                'courseId': courseId,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * @param courseId
     * @param requestBody
     * @returns Review review
     * @throws ApiError
     */
    public static upsertCourseReview(
        courseId: string,
        requestBody: ReviewInput,
    ): CancelablePromise<Review> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/lms/courses/{courseId}/reviews',
            path: {
                'courseId': courseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
